import React, { useEffect } from "react";
import Images from "../../images";
import { connect } from "react-redux";
import { Tile } from "carbon-components-react";
function ClassItem(props) {
  const { CourseName, TeacherName, LessonName, CourseImage, isClass } = props;

  return (
    <Tile className="course-card">
      <span className="course-title">{CourseName}</span>
      <span className="course-teacher-name">{TeacherName}</span>
      <div className="course-thumbnail-container">
        <img
          className="course-thumbnail-image"
          src={
            CourseImage && CourseImage !== "" ? CourseImage : Images.class_image
          }
          alt=" "
        />
      </div>
    </Tile>
  );
}
const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ClassItem);
